import { createAction } from '@reduxjs/toolkit';

export const fetchLeaders = createAction('dashboard/leaders');
export const fetchRecentProposalsChartData = createAction('dashboard/recentProposalsChartData');
export const fetchProposalsWidgetData = createAction('dashboard/proposalsWidgetData');
export const fetchFooterWidgetsData = createAction('dashboard/footerWidgetsData');
export const fetchProposalsByTypeData = createAction('dashboard/proposalsByTypeData');
